import * as tslib_1 from "tslib";
import { Base } from "../base-component";
import "./product-filter.component.scss";
import * as $ from "jquery";
var ProductFilter = /** @class */ (function (_super) {
    tslib_1.__extends(ProductFilter, _super);
    function ProductFilter(element) {
        var _this = _super.call(this, element) || this;
        _this.currentFilter = "";
        return _this;
    }
    ProductFilter.prototype.init = function () {
        var _this = this;
        this.queryParams = new URLSearchParams(window.location.search);
        var parseData = {};
        if (typeof jsonData !== "undefined") {
            parseData = jsonData;
        }
        this.filterJson = parseData.filters;
        this.productJson = parseData.products;
        this.filterItem = $(".product-filter__item");
        this.slideRunner = $(".product-filter__slide-runner");
        this.dropdown = $(".product-filter__dropdown");
        $(document).ready(function () {
            var params = _this.queryParams.get("filter");
            if (params) {
                var currentFilterItem = $(".product-filter__item[data-filter='" + params + "']");
                _this.moveSlideRunner(currentFilterItem);
                _this.filterProducts(params);
            }
            else {
                _this.currentFilter = _this.filterItem.first().data("filter");
                _this.moveSlideRunner(_this.filterItem.first());
            }
        });
    };
    ProductFilter.prototype.bindEvents = function () {
        var _this = this;
        this.dropdown.click(function (e) {
            $(".product-filter__wrapper").toggleClass("product-filter__wrapper--open");
        });
        $(document).on("click", ".product-filter__item", function (e) {
            var filter = $(e.currentTarget);
            _this.currentFilter = filter.data("filter");
            _this.moveSlideRunner(filter);
            $(".product-filter__dropdown-value-text").text(_this.currentFilter);
            $(".product-filter__wrapper").removeClass("product-filter__wrapper--open");
        });
        window.addEventListener("resize", this.debounce(function () {
            var currentFilterItem = $(".product-filter__item[data-filter='" + _this.currentFilter + "']");
            _this.moveSlideRunner(currentFilterItem);
        }, 250, false));
        $(document).on("click", ".product-filter__item", function (e) {
            var filter = $(e.currentTarget).data("filter");
            _this.filterProducts(filter);
        });
    };
    ProductFilter.prototype.filterProducts = function (tag) {
        var _this = this;
        $(".product-card").addClass("product-card--hide");
        var filtered = this.productJson.filter(function (prod) {
            return prod.tags.indexOf(tag) > -1;
        });
        var removed = this.productJson.filter(function (prod) {
            return prod.tags.indexOf(tag) == -1;
        });
        setTimeout(function () {
            _this.productJson.forEach(function (el) {
                $('.product-card[data-id="' + el.id + '"]').appendTo(".product-card-wrapper");
            });
            filtered.forEach(function (el) {
                $('.product-card[data-id="' + el.id + '"]')
                    .removeClass("product-card--filtered")
                    .removeClass("product-card--hide");
            });
            removed.forEach(function (el) {
                $('.product-card[data-id="' + el.id + '"]').addClass("product-card--filtered");
                $('.product-card[data-id="' + el.id + '"]').appendTo(".product-card-wrapper");
            });
        }, 200);
    };
    ProductFilter.prototype.moveSlideRunner = function (filter) {
        var filterPositionLeft = filter.position().left;
        var filterWidth = filter.width();
        this.slideRunner
            .width(0)
            .css("left", filterPositionLeft + 35 + "px")
            .show()
            .delay(350)
            .width(filterWidth);
    };
    ProductFilter.prototype.debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate)
                    func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow)
                func.apply(context, args);
        };
    };
    return ProductFilter;
}(Base));
export { ProductFilter };



//////////////////
// WEBPACK FOOTER
// ./components/product-filter/product-filter.component.ts
// module id = 444
// module chunks = 0